import React from "react";

export default function HomeLogo() {
  return (
    <React.Fragment>
      <svg
        viewBox="0 0 1144 1710"
        fill="none"
        className="home-logo"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M237.41 1710C106.305 1710 -0.0382315 1603.8 0.00770857 1472.69C0.0444418 1367.86 0.221594 1263.04 0.758616 1240.05C3.53896 1121.24 52.1131 1016.29 159.402 930.452C249.844 858.217 340.941 786.368 432.856 715.288C453.79 699.122 463.276 682.571 462.949 659.22C460.281 439.482 463.887 219.73 461.641 0H936.915C935.116 54.4004 938.878 110.854 935.607 165.126C928.901 275.338 881.799 373.618 782.361 453.679C696.007 523.091 609.162 592.246 519.701 659.091C486.5 683.982 472.762 709.386 473.253 745.568C474.499 881.097 474.822 1233.57 474.892 1472.71C474.93 1603.88 368.582 1710 237.41 1710V1710Z"
          fill="url(#paint0_linear_4948_55483)"
        />
        <path
          d="M444.41 1709C313.305 1709 206.962 1602.8 207.008 1471.7C207.044 1366.84 207.222 1261.98 207.759 1239C210.539 1120.29 259.113 1015.43 366.401 929.668C456.844 857.494 547.941 785.705 639.856 714.685C660.79 698.533 670.276 681.996 669.949 658.664C667.282 439.142 668.35 219.533 668.641 0H1143.92C1142.12 54.3545 1145.88 110.76 1142.61 164.987C1135.9 275.106 1088.8 373.303 989.361 453.296C903.007 522.65 816.162 591.747 726.701 658.536C693.5 683.406 679.762 708.788 680.253 744.939C681.499 880.342 681.822 1232.64 681.892 1471.7C681.93 1602.88 575.582 1709 444.41 1709V1709Z"
          fill="url(#paint1_linear_4948_55483)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4948_55483"
            x1="215.55"
            y1="1187.42"
            x2="574.184"
            y2="-56.6763"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0000F5" />
            <stop offset="1" stopColor="#41E58F" stopOpacity="0.13" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_4948_55483"
            x1="874.716"
            y1="233.469"
            x2="529.86"
            y2="1440.4"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#272727" />
            <stop offset="1" stopColor="#0000F5" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </React.Fragment>
  );
}
